<template>
  <div class='Box'>
    <el-card class="box-card">
      <el-form :model="queryParams" size="medium" label-width="100px" class="mt35">
        <el-row :gutter="35">

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="用户昵称">
              <el-input v-model="queryParams.name" @change="search" @clear="search" placeholder="请输入用户昵称"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button type="primary" size="medium" @click="search">查询</el-button>
              <el-button @click="addNoNe" size="medium">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%"
                size="medium"
                :header-cell-style="{textAlign:'center',background:'#f5f7fa'}" :cell-style="{textAlign:'center'}"
                @selection-change="handleSelectionChange" border v-loading="loading">
        <el-table-column label="用户ID">
          <template slot-scope="scope">{{ scope.row.id }}</template>
        </el-table-column>

        <el-table-column label="用户昵称">
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>

        <el-table-column prop="name" label="头像" width="120">
          <template slot-scope="scope">
            <el-image
                style="width: 80px; height: 80px"
                :src="scope.row.avatar?scope.row.avatar:defaultAvatar"
                :preview-src-list="[scope.row.avatar?scope.row.avatar:defaultAvatar]"
                fit="cover">
            </el-image>
          </template>
        </el-table-column>

        <el-table-column label="OpenId">
          <template slot-scope="scope">{{ scope.row.open_id }}</template>
        </el-table-column>

        <el-table-column label="手机号">
          <template slot-scope="scope">{{ scope.row.mobile }}</template>
        </el-table-column>

        <el-table-column label="小程序ID">
          <template slot-scope="scope">{{ scope.row.app_id }}</template>
        </el-table-column>

        <el-table-column prop="name" label="注册时间">
          <template slot-scope="scope">{{ scope.row.created_at }}</template>
        </el-table-column>

        <el-table-column label="最新活跃时间">
          <template slot-scope="scope">{{ scope.row.actived_at }}</template>
        </el-table-column>

        <el-table-column label="超管开关">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.is_super"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
                @change="changeSuperUser(scope.row.id)"
            >
            </el-switch>
          </template>
        </el-table-column>

      </el-table>
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo"
                  :limit.sync="queryParams.pageSize" @pagination="getList"/>
    </el-card>
  </div>
</template>

<script>
import {MoneyManagementAPI} from '@/api/MoneyManagement/MoneyManagement';
import {processErrors} from "@/utils/errorHandler";

export default {
  components: {},
  data() {
    return {
      queryParams: {
        pageNo: 1,
        pageSize: 10,
        name: ""
      },
      tableData: [],
      // 总条数
      total: 0,
      loading: false,
      defaultAvatar: "https://img.xinmeijiutian.com/license/v9XEPBQCOgTb0aCSDfFoEg0E5EyGKwAdTdCw7usa.jpg"
    };
  },
  created() {
    this.getList()
  },
  methods: {

    getList() {
      this.loading = true
      let api = MoneyManagementAPI()
      api.getUserList(this.queryParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.totalCount
        } else {
          processErrors(res);
        }
        this.loading = false
      })
    },

    changeSuperUser(id){
      let api = MoneyManagementAPI()
      api.userEdit({id:id}).then(res => {
        if (res.code == 0) {
          this.getList()
        } else {
          processErrors(res);
        }
      })
    },

    search() {
      this.getList()
    },
    addNoNe() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10,
        name: ""
      }
      this.getList()
    },
  },

  mounted() {

  },
}
</script>
<style lang='scss' scoped>
.Box {
  & ::v-deep el-card__body {

    padding: 0 !important;

  }
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}
</style>